module.exports = __webpack_public_path__ + "img/Collaboration-2021.bc2c4857.png";